"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEndOfDayInTimezone = exports.getLocalDate = exports.getUTCDate = exports.formatDate = void 0;
var date_fns_1 = require("date-fns");
var date_fns_tz_1 = require("date-fns-tz");
/**
 * Convert JS Date to string in the given format
 * @param date - Date to format
 * @param formatStr - Format to use
 * @param customFormat - Custom format to use if format is 'custom',
 * see date-fns doc for full list of format options: https://date-fns.org/v2.16.1/docs/format
 * @returns - Formatted date
 */
var formatDate = function (date, formatStr, customFormat) {
    switch (formatStr) {
        case 'litteral':
            return (0, date_fns_1.format)(date, 'MMMM dd, yyyy');
        case 'numeric':
            return (0, date_fns_1.format)(date, 'MM/dd/yyyy');
        case 'custom':
            return (0, date_fns_1.format)(date, customFormat || 'MM/dd/yyyy');
        default:
            return (0, date_fns_1.format)(date, 'MMMM dd, yyyy');
    }
};
exports.formatDate = formatDate;
/** Transform local date to UTC date at midnight */
var getUTCDate = function (localDate) {
    return (0, date_fns_1.startOfDay)(localDate);
};
exports.getUTCDate = getUTCDate;
/** Transform midnight UTC date to local date at midday */
var getLocalDate = function (UTCDate) {
    return (0, date_fns_1.setHours)(UTCDate, 12);
};
exports.getLocalDate = getLocalDate;
/**
 * Convert a date to a date representing the end of the day in a given timezone.
 * @param date Date to convert
 * @param timeZone Timezone to use, default is 'Europe/Paris'
 * @returns Date representing the end of the day in the given timezone
 */
var getEndOfDayInTimezone = function (date, timeZone) {
    if (timeZone === void 0) { timeZone = 'Europe/Paris'; }
    var endOfDayDate = (0, date_fns_1.endOfDay)(date);
    return (0, date_fns_tz_1.zonedTimeToUtc)(endOfDayDate, timeZone);
};
exports.getEndOfDayInTimezone = getEndOfDayInTimezone;
//# sourceMappingURL=date.js.map